module.exports = __webpack_public_path__ + "img/service_guide_map.f024e5f.png";